import * as React from 'react'
import { ErrorGroupObservation, ObservationState } from '../domain/Error'

interface Props {
    observation: ErrorGroupObservation
}

export class ObservationIcon extends React.PureComponent<Props> {
    public render() {
        const { observation } = this.props.observation

        if (observation.state === ObservationState.ERROR) {
            return (
                <span className="fa-stack">
                    <i className="fa fa-circle fa-stack-2x tw-color-red-100" />
                    <i className="fa fa-times fa-stack-1x tw-color-red-400" />
                </span>
            )
        }

        if (observation.state === ObservationState.WARNING) {
            return (
                <span className="fa-stack">
                    <i className="fa fa-circle fa-stack-2x tw-color-yellow-100" />
                    <i className="fa fa-warning fa-stack-1x tw-color-yellow-400" />
                </span>
            )
        }

        if (observation.state === ObservationState.UNKNOWN) {
            return (
                <span className="fa-stack">
                    <i className="fa fa-circle fa-stack-2x tw-color-grey-100" />
                    <i className="fa fa-question fa-stack-1x tw-color-grey-400" />
                </span>
            )
        }

        if (observation.state === ObservationState.IGNORE) {
            const tooltip =
                observation.state === ObservationState.IGNORE
                    ? 'This observation is ignored.'
                    : 'This observation is ignored and excluded for traces.'

            return (
                <span className="fa-stack" title={tooltip}>
                    <i className="fa fa-circle fa-stack-2x tw-color-grey-100" />
                    <i className="fa fa-ban fa-stack-1x tw-color-grey-400" />
                </span>
            )
        }

        return (
            <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x tw-color-cyan-100" />
                <i className="fa fa-check fa-stack-1x tw-color-cyan-400" />
            </span>
        )
    }
}
